import React from 'react';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material';

const CustomButton = ({
  sx = {},
  children,
  variant = 'contained',
  color = 'primary',
  onClick,
  startIcon,
  endIcon,
  disabled = false,
  ...props
}) => {
  const theme = useTheme();

  const customStyles = {
    ...(variant === 'contained' && {
      backgroundColor: disabled ? '#f1f5f9' : theme.palette.customSidebar.blue600,
      color: disabled ? '#757575' : '#ffffff',
      borderRadius: '8px',
      // fontWeight: 500,
      fontSize: '0.875rem',
      padding: '8px 16px',
      boxShadow: 'none',
      textTransform: 'none',
      whiteSpace: 'nowrap', // Prevent text wrapping
      transition: 'background 0.2s, color 0.2s',
      '&:hover': {
        backgroundColor: disabled ? '#f1f5f9' : theme.palette.customSidebar.blue700 || '#2563eb',
        color: '#fff',
        boxShadow: 'none',
      },
    }),
    ...(variant === 'outlined' && {
      backgroundColor: '#fff',
      border: `2.1px solid ${theme.palette.customSidebar.slate300 || '#cbd5e1'}`,
      color: theme.palette.customSidebar.blue600,
      borderRadius: '0.375rem',
      fontWeight: '400 !important',
      fontSize: '0.875rem',
      opacity: 0.9,
      height: '40px !important',
      padding: '8px 16px',
      textTransform: 'none',
      whiteSpace: 'nowrap', // Prevent text wrapping
      transition: 'background 0.2s, color 0.2s',
      '&:hover': {
        backgroundColor: theme.palette.customSidebar.slate50 || '#f8fafc',
        color: theme.palette.customSidebar.blue600,
        border: `2px solid ${theme.palette.customSidebar.slate300 || '#cbd5e1'}`,
      },
    }),
    ...sx, // merged custom styles
  };

  return (
    <Button
      sx={customStyles}
      variant={variant}
      color={color}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
